import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class SwalService {
  constructor() { }
  success(title: string, message?: string) {
    return Swal.fire({
      title: title,
      text: message,
      buttonsStyling: false,
      confirmButtonText: 'Aceptar',
      customClass: {
        icon: 'swal2-icon-custom',
      },
      iconHtml: `<img src="assets/icons/success.svg" alt="success" style="width: 80px; height: 80px;">`,
    });
  }

  showImageModal(options: {
    imageUrl: string;
    title?: string;
    showDownloadButton?: boolean;
  }) {
    const { imageUrl, title = 'Imagen', showDownloadButton = false } = options;
    const htmlContent = `
    <div class="text-center">
      <img src="${imageUrl}" alt="${title}" style="max-width: 100%; max-height: 70vh; margin-bottom: 10px;">
      
    </div>
  `;
    return Swal.fire({
      title: title,
      html: htmlContent,
      width: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      buttonsStyling: false,
      focusConfirm: false,
    });
  }

  error(title: string, message?: string) {
    return Swal.fire({
      icon: 'error',
      title: title,
      text: message,
      confirmButtonText: 'Aceptar',
      buttonsStyling: false,
    });
  }

  warning(title: string, message?: string) {
    return Swal.fire({
      icon: 'warning',
      title: title,
      text: message,
      confirmButtonText: 'Aceptar',
      buttonsStyling: false,
    });
  }

  info(title: string, message?: string) {
    return Swal.fire({
      icon: 'info',
      title: title,
      text: message,
      confirmButtonText: 'Aceptar',
      buttonsStyling: false,
    });
  }

  question(title: string, message?: string) {
    return Swal.fire({
      icon: 'question',
      title: title,
      text: message,
      confirmButtonText: 'Aceptar',
      buttonsStyling: false,
    });
  }

  verify(title: string, message?: string, textButton?: string) {
    return Swal.fire({
      title: title,
      text: message,
      showCancelButton: true,
      confirmButtonText: textButton,  // Cambiado para que coincida con tu imagen
      cancelButtonText: 'Cancelar',
      customClass: {
        popup: 'verify-popup',      // Clase para el contenedor principal
        confirmButton: 'verify-confirm-btn',  // Clase para el botón de confirmar
        cancelButton: 'verify-cancel-btn'     // Clase para el botón de cancelar
      },
      buttonsStyling: false,  // Desactiva los estilos por defecto de SweetAlert2
      showCloseButton: false  // Oculta la "X" de cerrar
    });
  }
}
